export default function GrantsApplicationSection({ title = null, description = null, children }) {

    return (
        <div className="grants-application-section">
            <div className="grants-application-section__block">
                { title !== null && <p className="grants-application-section__title">{ title }</p> }
                { description &&  typeof description == 'string' ? <div className="grants-application-section__description" dangerouslySetInnerHTML={{ __html: description }}></div> :
                                typeof description == 'object' && description }
            </div>
            { children }
        </div>
    )
}
